const LIVE = "EN VIVO";
const Live = "En Vivo";
const Play = "Reproducir";
const Pause = "Pausar";
const Mute = "Silenciar";
const Unmute = "Dejar de Silenciar";
const Subtitles = "Subtítulos";
const es = {
  LIVE,
  Live,
  "Not Live": "No En Vivo",
  Play,
  Pause,
  Mute,
  Unmute,
  "Tap to unmute": "Toca para dejar de silenciar",
  Subtitles,
  "Ad Playing": "Publicidad",
  "Picture-in-Picture": "Imagen-en-Imagen",
  "Full screen": "Pantalla Completa",
  "Exit full screen": "Salir de Pantalla Completa",
  "Rewind 10 Seconds": "Rebobinar 10 Segundos",
  "Rewind Icon": "Icono de Rebobinar",
  "Video Scrubber": "Depurador de Videos",
  "Closed captions": "Subtítulos",
  "Video Component Loading": "Componente de Video Está Cargando"
};
export {
  LIVE,
  Live,
  Mute,
  Pause,
  Play,
  Subtitles,
  Unmute,
  es as default
};
//# sourceMappingURL=translation.json.js.map
